<template>
  <div>
    <section class="main">
      <div class="container">
        <div class="row">
          <div
            class="col-6 col-md-3 col-lg-3"
            v-for="MenuData in OtherListData.Menus"
            :key="MenuData.Menu.MLId"
          >
            <div class="box">
              <a href="javascript:void(0);" @click="gotoMenu(MenuData.Menu)">
                <div
                  class="img-box"
                  :style="
                    'background: url(' +
                    OtherListData.SiteUrl +
                    MenuData.Menu.Image +
                    ') no-repeat center center; background-size:cover;'
                  "
                >
                  <!-- <img
                    :src="CategoryData.SiteUrl + Post.Image"
                    :alt="Post.Title"
                  /> -->
                </div>
                <p>{{ MenuData.Menu.Title }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Paginate from "vuejs-paginate";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.component("paginate", Paginate);
Vue.use(VueI18n);

// this.$t("關閉")
const messages = {
    zh_tw: {
    "關閉": "關閉",
  },
  en: {
    "關閉": "Close",
  },
  jp: {
    "關閉": "閉じる",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "OtherList",
  i18n,
  data() {
    return {
      OtherListData: {},
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      UserData: null,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/OtherList",
        {
          params: { lang: Storage.get("ek_site_lang") },
        }
      )
      .then((response) => {
        this.OtherListData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Member",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {},
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.UserData = JSON.parse(res.data);
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("others-list");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {},
  methods: {
    gotoMenu: function (Menu) {
      if (Menu.Title == "公車預約") {
        if (!this.UserData) {
          this.$router.push({
            name: "Login",
          });
        } else {
          if (this.isMobile && typeof cordova != "undefined") {
            cordova.InAppBrowser.open(
              "https://maas.foxconn.com/MaasBus/login?ID=" +
                this.UserData.User.Account,
              "_blank",
              "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
                this.$t("關閉") +
                ",closebuttoncolor=#ffffff"
            );
          } else {
            if (Menu.Blank) {
              window.open(
                "https://maas.foxconn.com/MaasBus/login?ID=" +
                  this.UserData.User.Account,
                "_blank"
              );
            } else {
              window.open(
                "https://maas.foxconn.com/MaasBus/login?ID=" +
                  this.UserData.User.Account
              );
            }
          }
        }
      } else {
        if (Menu.Type == 1) {
          this.$router.push({
            name: "Category",
            params: { CId: Menu.CId },
          });
        } else if (Menu.Type == 2) {
          this.$router.push({
            name: "Post",
            params: { PId: Menu.PId },
          });
        } else if (Menu.Type == 3) {
          if (this.isMobile && typeof cordova != "undefined") {
            cordova.InAppBrowser.open(
              Menu.Url,
              "_blank",
              "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
                this.$t("關閉") +
                ",closebuttoncolor=#ffffff"
            );
          } else {
            if (Menu.Blank) {
              window.open(Menu.Url, "_blank");
            } else {
              window.open(Menu.Url);
            }
          }
        }
      }
    },
  },
  updated: function () {},
};

Vue.filter("timeString", function (value, myFormat) {
  return moment(value).format(myFormat || "YYYY-MM-DD, HH:mm:ss");
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OtherList.vue